import React from 'react';
import PropTypes from 'prop-types'; // ES6
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from './Actions';
import InputSelect from '../../components/InputSelect';

class Selector extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      database: this.props.statuses,
    };

    this.hasRequestedInitialLoad = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ database: nextProps.statuses });
  }

  componentDidMount() {
    if (this.state.database.length === 0 && !this.hasRequestedInitialLoad) {
      this.props.actions.load();
      this.hasRequestedInitialLoad = true;
    }
  }

  render() {
    return (
      <InputSelect
        field="name"
        name="status_id"
        database={this.state.database}
        id={this.props.id}
        value={this.props.value}
        deleted={this.props.deleted}
        disabled={this.props.disabled}
        onChange={this.props.onChange}
        nullValue="" />
    );
  }
}

Selector.propTypes = {
  statuses: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  deleted: PropTypes.bool,
  disabled: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return { statuses: state.statusState };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Selector);
